import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
// import AuditTable from "@components/Dashboard/Audittable";
// import BreakupBox from "@components/Audit/breakup-box";
// import GraphTable from "@components/Dashboard/graph";
import "./index.scss";
import "./breakup-box.scss";
import qs from "query-string";
import { useNavigate } from "react-router-dom";
import moment from "moment";
// import { adminGetAuditDashboardInfo } from "@services/dashboard.service";
import { getValue } from "@utils/lodash";
import DatePicker from "react-date-picker";
import { getDashboardInfo } from "@services/checkpoint.service";
import { CheckDecimal } from "@_common/check-decimal";
import { monthsString } from "@_common/month";
import {
	adminGetCountriesListManagement,
	adminGetStatesListManagement,
} from "@services/list-management.service";
import { Bar } from "react-chartjs-2";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import InputField from "@_common/InputRuleFeild";
import { Table } from "reactstrap";
import { toast } from "react-toastify";
import { formatDecimal } from "@_common/text-helper";
import ExpandableTable from "@components/Dashboard/ExpandableTable";
import { QueryRequestHelper } from "@_common/query-request-helper";
import CalenderDropdown from "@_common/CalenderDropdown";
import Loader from "@components/common/Loader";
ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ChartDataLabels
);
export default function Compliance() {
	const navigate = useNavigate();
	/* -------------------------------------------------------------------------- */
	/*                         usestate Section                                   */
	/* -------------------------------------------------------------------------- */
	const [summaryInfo, setSummaryInfo] = useState({});
	const [overViewInfo, setOverviewInfo] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [countryList, setCountryList] = useState([]);
	const [states, setStates] = useState([]);
	const [country_id, setCountry_id] = useState<any>();
	const [state_id, setState_id] = useState<any>();

	/* -------------------------------------------------------------------------- */
	/*                        Useeffect Section                                   */
	/* -------------------------------------------------------------------------- */

	// useEffect(() => {
	// 	const urlSearchParams = new URLSearchParams(window.location.search);
	// 	const params = Object.fromEntries(urlSearchParams.entries());
	// 	if (Object.keys(params).length === 0) {
	// 		setDate(new Date());
	// 		getSummaryData();
	// 		getOverviewData();
	// 		getCatrgoryData();
	// 		getAuditUploadLcoationData();
	// 		getAuditUploadVendorData();
	// 		// getLocationData();
	// 		// getMonthData();
	// 		// getAuditUploadLcoationData();
	// 		// getAuditUploadLcoationVendorData();
	// 		getCountriesList();
	// 		if (params.country_id) {
	// 			setCountry_id(parseInt(params.country_id));
	// 		} else {
	// 			setCountry_id(101);
	// 		}
	// 		if (params.state_id) {
	// 			setState_id(parseInt(params.state_id));
	// 		} else {
	// 			setState_id(4026);
	// 		}
	// 	}
	// }, []);
	// useEffect(() => {
	// 	const urlSearchParams = new URLSearchParams(window.location.search);
	// 	const params = Object.fromEntries(urlSearchParams.entries());
	// 	if (Object.keys(params).length > 0) {
	// 		getCountriesList();
	// 		getSummaryData();
	// 		getOverviewData();
	// 		getCatrgoryData();
	// 		getAuditUploadLcoationData();
	// 		getAuditUploadVendorData();
	// 		// getLocationData();
	// 		// getMonthData();
	// 		// getAuditUploadLcoationData();
	// 		// getAuditUploadLcoationVendorData();
	// 		if (params.date) {
	// 			setDate(new Date(params.date));
	// 		} else {
	// 			setDate(new Date());
	// 		}
	// 		if (params.country_id) {
	// 			setCountry_id(parseInt(params.country_id));
	// 		} else {
	// 			setCountry_id(101);
	// 		}
	// 		if (params.state_id) {
	// 			setState_id(parseInt(params.state_id));
	// 		} else {
	// 			setState_id(4026);
	// 		}
	// 	}
	// }, [window.location.href]);

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0) {
			getOverviewData();
			getSummaryData();
			getCatrgoryData();
			getAuditUploadLcoationData();
			getAuditUploadVendorData();
			getCountriesList();
			if (params.country_id) {
				setCountry_id(parseInt(params.country_id));
			} else {
				setCountry_id(101);
			}
			if (params.state_id) {
				setState_id(parseInt(params.state_id));
			} else {
				setState_id(4026);
			}
			setDate(new Date());
		}
	}, []);
	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0) {
			getOverviewData();
			getCountriesList();
			getSummaryData();
			getCatrgoryData();
			getAuditUploadLcoationData();
			getAuditUploadVendorData();
			if (params.date) {
				setDate(new Date(params.date));
			} else {
				setDate(new Date());
			}
			if (params.country_id) {
				setCountry_id(parseInt(params.country_id));
				//con
				getStatesList(parseInt(params.country_id));
			} else {
				setCountry_id(101);
			}
			if (params.state_id) {
				setState_id(parseInt(params.state_id));
				//cond
				getLocationData(parseInt(params.state_id));
				getMonthData();
			} else {
				setState_id(4026);
			}
		}
	}, [window.location.href]);

	useEffect(() => {
		if (country_id && state_id) {
			getLocationData(state_id);
			getMonthData();
		}
		if (country_id) {
			getStatesList(country_id);
		}
	}, [country_id, state_id]);

	/* -------------------------------------------------------------------------- */
	/*                              API Section                                   */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		if (country_id) getStatesList(country_id);
	}, [country_id]);

	const getCountriesList = async () => {
		try {
			let resp = await adminGetCountriesListManagement();
			if (resp) {
				setCountryList(
					getValue(resp, `data.countries`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const getStatesList = async (countryId: number) => {
		if (countryId) {
			try {
				let resp = await adminGetStatesListManagement(countryId);
				if (resp) {
					setStates(
						getValue(resp, `data.states`, []).map((item: object) => ({
							...item,
							value: getValue(item, `name`, ""),
							label: getValue(item, `name`, ""),
						}))
					);
				} else {
				}
			} catch (error) {}
		}
	};
	const handleChangeSelect = (e: any, type: string) => {
		if (type === "country_id") {
			getStatesList(e.id);
			setStates([]);
		}
		if (type === "state_id") {
			setState_id(e.id);
			setData({
				...data,
				labels: "",
				datasets: [],
			});
			let payload: any = {
				state_id: e.id,
			};
			// removing null values
			Object.keys(payload).forEach((key) => {
				if (!payload[key] || payload[key] === undefined) {
					delete payload[key];
				}
			});
			let queryRequest = qs.stringify(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
			// getLocationData(e.id);
		}
	};
	const getOverviewData = async () => {
		try {
			let payload = {
				type: "OVERVIEW",
			};
			setIsLoading(true);
			let resp = await getDashboardInfo(payload);
			if (resp) {
				setOverviewInfo(getValue(resp, `data.overview`, {}));
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};
	const getSummaryData = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let dates = date ? date : new Date();
		try {
			let payload = {
				month: params.date
					? parseInt(params.date.split("-")[1])
					: date
					? parseInt(moment(date).format("M"))
					: parseInt(moment(dates).format("M")),
				year: params.date
					? parseInt(params.date.split("-")[0])
					: date
					? parseInt(moment(date).format("YYYY"))
					: parseInt(moment(dates).format("YYYY")),
				// country_id: country_id,
				// state_id: state_id,
				type: "SUMMERY",
			};
			let resp = await getDashboardInfo(payload);
			if (resp) {
				setSummaryInfo(getValue(resp, `data`, {}));
			}
		} catch (error) {}
	};
	const getLocationData = async (id: any) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let dates = date ? date : new Date();
		try {
			let payload = {
				month: params.date
					? parseInt(params.date.split("-")[1])
					: date
					? parseInt(moment(date).format("M"))
					: parseInt(moment(dates).format("M")),
				year: params.date
					? parseInt(params.date.split("-")[0])
					: date
					? parseInt(moment(date).format("YYYY"))
					: parseInt(moment(dates).format("YYYY")),
				country_id: country_id,
				state_id: id,
				type: "LOCATION",
			};
			let resp = await getDashboardInfo(payload);
			if (resp) {
				if (getValue(resp, `data.length`, 0) > 0) {
					let labels: any = [];
					labels =
						getValue(resp, `data.length`, 0) > 0 &&
						getValue(resp, `data`, []).map((item: any) => Object.keys(item));
					let finalLabels = [].concat(...labels);
					let complaince_data: any = [];
					let non_complaince_data: any = [];
					for (let i = 0; i < getValue(resp, `data.length`, 0); i++) {
						complaince_data.push(
							CheckDecimal(
								getValue(resp, `data[${i}]${labels[i]}.compliance_score`, 0)
							)
						);
						non_complaince_data.push(
							CheckDecimal(
								getValue(resp, `data[${i}]${labels[i]}.non_compliance_score`, 0)
							)
						);
					}
					setData({
						...data,
						labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
						datasets: [
							{
								label: "Non-Compliant",
								data: non_complaince_data,
								backgroundColor: "#E8F0FE",
								barThickness: 70,
							},
							{
								label: "Compliant",
								data: complaince_data,
								backgroundColor: "#72A4F7",
								barThickness: 70,
							},
						],
					});
				} else {
					setData({
						...data,
						labels: [""],
						datasets: [
							{
								label: "",
								data: [0, 0],
								backgroundColor: "rgba(255, 99, 132, 0.5)",
								barThickness: 10,
							},
						],
					});
				}
			}
		} catch (error) {}
	};
	const getMonthData = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let dates = date ? date : new Date();
		try {
			let payload = {
				year: params.date
					? parseInt(params.date.split("-")[0])
					: date
					? parseInt(moment(date).format("YYYY"))
					: parseInt(moment(dates).format("YYYY")),
				// country_id: country_id,
				// state_id: state_id,
				type: "MONTH",
			};
			let resp = await getDashboardInfo(payload);
			if (resp) {
				if (getValue(resp, `data.length`, 0) > 0) {
					let labels: any = [];
					labels =
						getValue(resp, `data.length`, 0) > 0 &&
						getValue(resp, `data`, []).map((item: any) => Object.keys(item));
					let finalLabels = [].concat(...labels);
					let complaince_data: any = [];
					let non_complaince_data: any = [];
					for (let i = 0; i < getValue(resp, `data.length`, 0); i++) {
						complaince_data.push(
							CheckDecimal(
								getValue(resp, `data[${i}]${labels[i]}.compliance_score`, 0)
							)
						);
						non_complaince_data.push(
							CheckDecimal(
								getValue(resp, `data[${i}]${labels[i]}.non_compliance_score`, 0)
							)
						);
					}
					let formatedMonths = finalLabels.map((item) => {
						let year = params.date
							? parseInt(params.date.split("-")[0])
							: date
							? parseInt(moment(date).format("YY"))
							: parseInt(moment(dates).format("YY"));
						return `${monthsString[parseInt(item)]}-${year}`;
					});
					setMonthData({
						...monthData,
						labels:
							getValue(formatedMonths, `length`, 0) > 0 ? formatedMonths : [],
						datasets: [
							{
								label: "Non-Compliant",
								data: non_complaince_data,
								backgroundColor: "#E8F0FE",
								barThickness: 70,
							},
							{
								label: "Compliant",
								data: complaince_data,
								backgroundColor: "#72A4F7",
								barThickness: 70,
							},
						],
					});
				} else {
					setMonthData({
						...monthData,
						labels: [""],
						datasets: [
							{
								label: "",
								data: [0, 0],
								backgroundColor: "rgba(255, 99, 132, 0.5)",
								barThickness: 10,
							},
						],
					});
				}
			}
		} catch (error) {}
	};
	const getCatrgoryData = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let dates = date ? date : new Date();
		try {
			let payload = {
				month: params.date
					? parseInt(params.date.split("-")[1])
					: date
					? parseInt(moment(date).format("M"))
					: parseInt(moment(dates).format("M")),
				year: params.date
					? parseInt(params.date.split("-")[0])
					: date
					? parseInt(moment(date).format("YYYY"))
					: parseInt(moment(dates).format("YYYY")),
				type: "CATEGORY",
			};
			let resp = await getDashboardInfo(payload);
			if (resp) {
				if (getValue(resp, `data.length`, 0) > 0) {
					let labels: any = [];
					labels =
						getValue(resp, `data.length`, 0) > 0 &&
						getValue(resp, `data`, []).map((item: any) => Object.keys(item));
					let finalLabels = [].concat(...labels);
					let complaince_data: any = [];
					let non_complaince_data: any = [];
					for (let i = 0; i < getValue(resp, `data.length`, 0); i++) {
						complaince_data.push(
							CheckDecimal(
								getValue(resp, `data[${i}]${labels[i]}.compliance_score`, 0)
							)
						);
						non_complaince_data.push(
							CheckDecimal(
								getValue(resp, `data[${i}]${labels[i]}.non_compliance_score`, 0)
							)
						);
					}
					setCategoryData({
						...categoryData,
						labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
						datasets: [
							{
								label: "Non-Compliant",
								data: non_complaince_data,
								backgroundColor: "#E8F0FE",
								barThickness: 70,
							},
							{
								label: "Compliant",
								data: complaince_data,
								backgroundColor: "#72A4F7",
								barThickness: 70,
							},
						],
					});
				} else {
					setCategoryData({
						...categoryData,
						labels: [""],
						datasets: [
							{
								label: "",
								data: [0, 0],
								backgroundColor: "rgba(255, 99, 132, 0.5)",
								barThickness: 10,
							},
						],
					});
				}
			}
		} catch (error) {}
	};
	const [auditUploadLocations, setAuditUploadLocations] = useState([]);
	const getAuditUploadLcoationData = async () => {
		try {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let dates = date ? date : new Date();
			let payload = {
				month: params.date
					? parseInt(params.date.split("-")[1])
					: date
					? parseInt(moment(date).format("M"))
					: parseInt(moment(dates).format("M")),
				year: params.date
					? parseInt(params.date.split("-")[0])
					: date
					? parseInt(moment(date).format("YYYY"))
					: parseInt(moment(dates).format("YYYY")),
				type: "AUDIT_UPLOAD_LOCATION",
			};
			let resp = await getDashboardInfo(payload);
			if (resp) {
				setAuditUploadLocations(
					getValue(resp, `data`, []).map((item: any) => ({
						// console.log(Object.entries(item))
						id: Object.keys(item)[0].split("::")[0],
						location:
							Object.entries(item).length > 0
								? Object.entries(item)[0][0].split("::")[1]
								: "",
						auditData: item[Object.entries(item)[0][0]],
					}))
				);
			}
		} catch (error) {}
	};

	const [vendorsByLocation, setVendorsByLocation] = useState([]);
	const getAuditUploadLcoationVendorData = async (id: string) => {
		if (id) {
			try {
				const urlSearchParams = new URLSearchParams(window.location.search);
				const params = Object.fromEntries(urlSearchParams.entries());
				let dates = date ? date : new Date();
				let payload = {
					month: params.date
						? parseInt(params.date.split("-")[1])
						: date
						? parseInt(moment(date).format("M"))
						: parseInt(moment(dates).format("M")),
					year: params.date
						? parseInt(params.date.split("-")[0])
						: date
						? parseInt(moment(date).format("YYYY"))
						: parseInt(moment(dates).format("YYYY")),
					country_id: country_id,
					location_id: id,
					// year: 2022,
					type: "AUDIT_UPLOAD_LOCATION_VENDOR",
				};
				let resp = await getDashboardInfo(payload);
				if (resp) {
					setVendorsByLocation(
						getValue(resp, `data`, []).map((item: any) => ({
							// console.log(Object.entries(item))
							id: Object.keys(item)[0].split("::")[0],
							location:
								Object.entries(item).length > 0
									? Object.entries(item)[0][0].split("::")[1]
									: "",
							auditData: item[Object.entries(item)[0][0]],
						}))
					);
				} else {
					setVendorsByLocation([]);
				}
			} catch (error) {
				setVendorsByLocation([]);
			}
		} else {
		}
	};

	const [auditUploadVendor, setAuditUploadVendor] = useState([]);
	const getAuditUploadVendorData = async () => {
		try {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let dates = date ? date : new Date();
			let payload = {
				month: params.date
					? parseInt(params.date.split("-")[1])
					: date
					? parseInt(moment(date).format("M"))
					: parseInt(moment(dates).format("M")),
				year: params.date
					? parseInt(params.date.split("-")[0])
					: date
					? parseInt(moment(date).format("YYYY"))
					: parseInt(moment(dates).format("YYYY")),

				type: "AUDIT_UPLOAD_VENDOR",
			};
			let resp = await getDashboardInfo(payload);
			if (resp) {
				setAuditUploadVendor(
					getValue(resp, `data`, []).map((item: any) => ({
						// console.log(Object.entries(item))
						location:
							Object.entries(item).length > 0
								? Object.entries(item)[0][0].split("::")[1]
								: "",
						auditData: item[Object.entries(item)[0][0]],
					}))
				);
			}
		} catch (error) {}
	};

	const getAuditUploadVendorCityDataInside = async () => {
		try {
			let payload = {
				country_id: country_id,
				state_id: state_id,
				// year: 2022,
				vendor: "accenture.com",
				type: "AUDIT_UPLOAD_VENDOR_CITY",
			};
			let resp = await getDashboardInfo(payload);
			if (resp) {
			}
		} catch (error) {}
	};
	/* -------------------------------------------------------------------------- */
	/*                              Date Routes                                   */
	/* -------------------------------------------------------------------------- */
	const [date, setDate] = useState<any>(null);
	const handleSubmitDate = () => {
		let dates = moment(date).format("YYYY-MM-DD");
		if (dates && dates !== "Invalid date") {
			let payload: any = {
				date: dates,
				country_id: country_id,
				state_id: state_id,
			};
			// removing null values
			Object.keys(payload).forEach((key) => {
				if (!payload[key] || payload[key] === undefined) {
					delete payload[key];
				}
			});
			let queryRequest = qs.stringify(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		} else {
			toast.error("Please select date");
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                              Chart Section                                 */
	/* -------------------------------------------------------------------------- */

	const options: any = {
		responsive: true,
		plugins: {
			datalabels: {
				anchor: "start",
				align: "end",
				labels: {
					value: {
						color: "black",
					},
				},
				formatter: (val: any) => {
					return val + "%";
				},
			},
			legend: {
				position: "top",
			},
			title: {
				display: false,
				text: "Chart.js Bar Chart",
			},
		},
	};

	const [data, setData] = useState<any>({
		labels: [],
		datasets: [
			{
				label: "Location 1",
				data: [0, 0],
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "Location 2",
				data: [0, 0],
				backgroundColor: "rgba(53, 162, 235, 0.5)",
				barThickness: 10,
			},
		],
	});

	const [monthData, setMonthData] = useState<any>({
		labels: [],
		datasets: [
			{
				label: "Month 1",
				data: [0, 0],
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "Month 2",
				data: [0, 0],
				backgroundColor: "rgba(53, 162, 235, 0.5)",
				barThickness: 10,
			},
		],
	});
	const [categoryData, setCategoryData] = useState<any>({
		labels: [],
		datasets: [
			{
				label: "Category 1",
				data: [0, 0],
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "Category 2",
				data: [0, 0],
				backgroundColor: "rgba(53, 162, 235, 0.5)",
				barThickness: 10,
			},
		],
	});

	let country_ID = countryList.filter(
		(item: object) => getValue(item, `id`, "") == country_id
	);
	let state_ID = states.filter(
		(item: object) => getValue(item, `id`, "") == state_id
	);

	const handleNavigateUpload = (status: string) => {
		let dates = moment(date).format("YYYY-MM-DD");
		if (dates && dates !== "Invalid date") {
			let payload = {
				// status:status,
				// date:dates
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(
				`/dashboard/checkpoint/details/${status}/${dates}/-/1?${queryRequest}`
			);
		}
	};
	const handleNavigateAudit = (status: string) => {
		let dates = moment(date).format("YYYY-MM-DD");
		if (dates && dates !== "Invalid date") {
			let payload = {
				// status:status,
				// date:dates
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(
				`/dashboard/checkpoint/details/-/${dates}/${status}/1?${queryRequest}`
			);
		}
	};
	return (
		<DashboardLayout>
			{/* {isLoading ? (
				<p className="text-center mt-2">Please wait...</p>
			) : ( */}
			<>
				<div className="dashboard-wrapper__header">
					<h4 className="dashbaord-wrapper__header-title">Check Points</h4>
				</div>
				{isLoading ? (
					<Loader />
				) : (
					<div className="overview-wrapper p-5">
						{/* <div className="breakup-wrapper d-flex align-items-center box-gap"> */}
						{/* <section
							className={`breakup-box breakup-box--${"green-color"} breakup-box--blue-bg`}
						>
							<div className="breakup-box__details">
								<h6 className={`breakup-box__title breakup-box__title--`}>
									{getValue(overViewInfo, `vendor_count`, "0")}
								</h6>
								<p
									className={`breakup-box__text breakup-box__text--${"blue-color"}`}
								>
									Vendors
								</p>
							</div>
							<img
								src={`/images/dashboard/vender-audit/engineering.svg`}
								className="img-fluid breakup-box-image"
							/>
						</section>
						<section
							className={`breakup-box breakup-box-- breakup-box--green-bg`}
						>
							<div className="breakup-box__details">
								<h6 className={`breakup-box__title breakup-box__title--`}>
									{getValue(overViewInfo, `location_count`, "0")}
								</h6>
								<p
									className={`breakup-box__text breakup-box__text--${"green-color"}`}
								>
									Locations
								</p>
							</div>
							<img
								src={`/images/dashboard/vender-audit/beenhere.svg`}
								className="img-fluid breakup-box-image"
							/>
						</section> */}
						{/* <section className={`breakup-box breakup-box-- breakup-box--orange-bg`}>
							<div className="breakup-box__details">
								<h6 className={`breakup-box__title breakup-box__title--`}>
									{getValue(overViewInfo, `vendor_location_count`, "0")}
								</h6>
								<p
									className={`breakup-box__text breakup-box__text--${"orange-color"}`}
								>
									Avg Vendor/Location
								</p>
							</div>
							<img
								src={`/images/dashboard/vender-audit/people.svg`}
								className="img-fluid breakup-box-image"
							/>
						</section> */}
						{/* </div> */}
						<div className="dashboard-compliance">
							<div className="dashboard-compliance__common d-flex align-items-center justify-content-between">
								<h3 className="dashboard-compliance__title">
									Average Audit Score -{" "}
									<span>
										{formatDecimal(
											getValue(summaryInfo, `auditScore.compliance_score`, "")
										)}
										%
									</span>
								</h3>
								<h3 className="dashboard-compliance__date dashboard-compliance__date--compliance overview-wrapper__header-date d-flex align-items-center">
									{/* <div className="mb-3">
									<DatePicker
										onChange={setDate}
										value={date}
										format="MMM yyyy"
										disableCalendar={true}
										yearAriaLabel={"yyyy"}
									/>
									<button className="apply-btn" onClick={handleSubmitDate}>
										Apply
									</button>
								</div> */}
									{/* <img src="/images/arrow-drop.svg" className="img-fluid" /> */}
									<CalenderDropdown
										onChange={setDate}
										value={date}
										handleSubmitDate={handleSubmitDate}
									/>
								</h3>
							</div>
							<div className="d-flex align-items-center box-gap mb-3">
								<section
									className="breakup-box"
									onClick={() =>
										getValue(summaryInfo, `summery.uploaded_count`, 0) > 0 &&
										handleNavigateUpload("UPLOADED")
									}
								>
									<div className="breakup-box__details">
										<h6 className="breakup-box__title">
											{getValue(summaryInfo, `summery.uploaded_count`, "0")}
										</h6>
										<p className="breakup-box__text">{"Uploaded"}</p>
									</div>
									<img
										src={`/images/upload-image.svg`}
										className="img-fluid breakup-box-image"
									/>
								</section>
								<section
									className="breakup-box"
									onClick={() =>
										getValue(summaryInfo, `summery.not_uploaded_count`, 0) >
											0 && handleNavigateUpload("NOT_UPLOADED")
									}
								>
									<div className="breakup-box__details">
										<h6 className="breakup-box__title">
											{getValue(summaryInfo, `summery.not_uploaded_count`, "0")}
										</h6>
										<p className="breakup-box__text">{"Not Uploaded"}</p>
									</div>
									<img
										src={`/images/not-uploaded-image.svg`}
										className="img-fluid breakup-box-image"
									/>
								</section>
							</div>
						</div>

						<div className="dashboard-compliance">
							<div className="dashboard-compliance__common d-flex align-items-center justify-content-between">
								<h3 className="dashboard-compliance__title">
									Uploaded Audit Breakup
								</h3>
								{/* <h3 className="dashboard-compliance__date overview-wrapper__header-date d-flex align-items-center">
									Jan 22, 2021 - Jan 22, 2022<img src="/images/arrow-drop.svg" className="img-fluid" />
									</h3> */}
							</div>
							<div className="dashboard-compliance__closed d-flex align-items-center box-gap mb-3">
								<section
									className="breakup-box"
									onClick={() =>
										getValue(summaryInfo, `summery.pending_audit_count`, 0) >
											0 && handleNavigateAudit("PENDING_AUDIT")
									}
								>
									<div className="breakup-box__details">
										<h6 className="breakup-box__title">
											{getValue(
												summaryInfo,
												`summery.pending_audit_count`,
												"0"
											)}
										</h6>
										<p className="breakup-box__text">{"Pending Audit"}</p>
									</div>
									<img
										src={`/images/upload-image.svg`}
										className="img-fluid breakup-box-image"
									/>
								</section>

								<section
									className="breakup-box"
									onClick={() =>
										getValue(summaryInfo, `summery.complied_count`, 0) > 0 &&
										handleNavigateAudit("COMPLIED")
									}
								>
									<div className="breakup-box__details">
										<h6 className="breakup-box__title">
											{getValue(summaryInfo, `summery.complied_count`, "0")}
										</h6>
										<p className="breakup-box__text">{"Compiled"}</p>
									</div>
									<img
										src={`/images/chk-circle-green.svg`}
										className="img-fluid breakup-box-image"
									/>
								</section>

								<section
									className="breakup-box"
									onClick={() =>
										getValue(summaryInfo, `summery.non_complied_count`, 0) >
											0 && handleNavigateAudit("NON_COMPLIED")
									}
								>
									<div className="breakup-box__details">
										<h6 className="breakup-box__title">
											{getValue(summaryInfo, `summery.non_complied_count`, "0")}
										</h6>
										<p className="breakup-box__text">{"Non-Complied"}</p>
									</div>
									<img
										src={`/images/upload-image.svg`}
										className="img-fluid breakup-box-image"
									/>
								</section>

								<section
									className="breakup-box"
									onClick={() =>
										getValue(
											summaryInfo,
											`summery.partially_complied_count`,
											0
										) > 0 && handleNavigateAudit("PARTIALLY_COMPLIED")
									}
								>
									<div className="breakup-box__details">
										<h6 className="breakup-box__title">
											{getValue(
												summaryInfo,
												`summery.partially_complied_count`,
												"0"
											)}
										</h6>
										<p className="breakup-box__text">{"Partially Complied"}</p>
									</div>
									<img
										src={`/images/flaky.svg`}
										className="img-fluid breakup-box-image"
									/>
								</section>

								<section
									className="breakup-box"
									onClick={() =>
										getValue(summaryInfo, `summery.not_applicable_count`, 0) >
											0 && handleNavigateAudit("NOT_APPLICABLE")
									}
								>
									<div className="breakup-box__details">
										<h6 className="breakup-box__title">
											{getValue(
												summaryInfo,
												`summery.not_applicable_count`,
												"0"
											)}
										</h6>
										<p className="breakup-box__text">{"Not Applicable"}</p>
									</div>
									<img
										src={`/images/upload-image.svg`}
										className="img-fluid breakup-box-image"
									/>
								</section>

								<section
									className="breakup-box"
									onClick={() =>
										getValue(
											summaryInfo,
											`summery.send_back_to_vendor_count`,
											0
										) > 0 && handleNavigateAudit("SEND_BACK_TO_VENDOR")
									}
								>
									<div className="breakup-box__details">
										<h6 className="breakup-box__title">
											{getValue(
												summaryInfo,
												`summery.send_back_to_vendor_count`,
												"0"
											)}
										</h6>
										<p className="breakup-box__text">{"Sent Back to Vendor"}</p>
									</div>
									<img
										src={`/images/upload-image.svg`}
										className="img-fluid breakup-box-image"
									/>
								</section>
							</div>
						</div>

						<div className="w-100 mb-5">
							<div className="loaction-wise-wrapper">
								<div className="overview-wrapper__header d-flex align-items-center justify-content-between">
									<h3 className="overview-wrapper__header-title">
										Location Wise Compliance Status
									</h3>
									{/* <div className="loaction-wise-list">
										<ul className="d-flex align-items-center">
											<li className="loaction-wise-list-item">Non-Compliant</li>
											<li className="loaction-wise-list-item">Compliant</li>
										</ul>
									</div> */}
								</div>
								<div className="vendor-graph">
									<Bar options={options} data={data} height={70} />
								</div>
								<div className="overview-wrapper__header vendor-graph-border p-3 m-0">
									<div className="filter-form-wrappper__container d-flex">
										<div className="filter-form-wrappper__location-form-group form-group">
											<div className="grid">
												<div className="input-grid-item">
													<label
														htmlFor="State"
														className="filter-form-wrappper__label"
													>
														State
													</label>
													<div className="filter-form-wrappper__location-input">
														<InputField
															inputType="INPUT_REACT_SELECT_MODAL"
															placeholder="Choose State"
															className="form-control w-100"
															name="state_id"
															id="state_id"
															// label="Last Name"
															options={states}
															value={state_ID}
															onChange={(e: any) =>
																handleChangeSelect(e, "state_id")
															}
															isClear
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="w-100 mb-5">
							<div className="loaction-wise-wrapper">
								<div className="overview-wrapper__header d-flex align-items-center justify-content-between">
									<h3 className="overview-wrapper__header-title">
										Month Wise Compliance Status
									</h3>
									{/* <div className="loaction-wise-list">
										<ul className="d-flex align-items-center">
											<li className="loaction-wise-list-item">Non-Compliant</li>
											<li className="loaction-wise-list-item">Compliant</li>
										</ul>
									</div> */}
								</div>
								<div className="vendor-graph">
									<Bar options={options} data={monthData} height={70} />
								</div>
							</div>
						</div>
						<br />
						<div className="w-100 mb-5">
							<div className="loaction-wise-wrapper">
								<div className="overview-wrapper__header d-flex align-items-center justify-content-between">
									<h3 className="overview-wrapper__header-title">
										Category Wise Compliance Status
									</h3>
									{/* <div className="loaction-wise-list">
										<ul className="d-flex align-items-center">
											<li className="loaction-wise-list-item">Non-Compliant</li>
											<li className="loaction-wise-list-item">Compliant</li>
										</ul>
									</div> */}
								</div>
								<div className="vendor-graph">
									<Bar options={options} data={categoryData} height={70} />
								</div>
							</div>
						</div>
						<br />
						<div className="w-100 mb-5 mt-3">
							<div className="loaction-wise-wrapper">
								<div className="overview-wrapper__header d-flex align-items-center justify-content-between">
									<h3 className="overview-wrapper__header-title">
										Location Wise Audit Uploaded
									</h3>
								</div>
								<ExpandableTable
									auditUploadLocations={auditUploadLocations}
									handleClickRow={getAuditUploadLcoationVendorData}
									vendorsByLocation={vendorsByLocation}
									headers={[
										"Location",
										"Uploaded",
										"NotUploaded",
										"Complied",
										"Not Complied",
										"Not Applicable",
										"Partially Complied",
										"Score",
									]}
								/>
							</div>
						</div>

						{/* <div className="w-100">
						<div className="loaction-wise-wrapper">
							<div className="overview-wrapper__header d-flex align-items-center justify-content-between">
								<h3 className="overview-wrapper__header-title">
									Vendor Wise Audit Uploaded
								</h3>
							</div>
							<br />
							<br />
							<div className="vendor-graph">
								<Table>
									<thead>
										<th>Location</th>
										<th>Uploaded</th>
										<th>NotUploaded</th>
										<th>Complied</th>
										<th>Not Complied</th>
										<th>Not Applicable</th>
										<th>Partially Complied</th>
										<th>Score</th>
									</thead>
									<tbody>
										{
										auditUploadVendor.length>0?
										
										auditUploadVendor.map((item, index) => {
											return (
												<tr key={index}>
													<td>{getValue(item, `location`, "")}</td>
													<td>
														{getValue(
															item,
															`auditData.auditCount.uploaded_count`,
															""
														)}
														
													</td>
													<td>
														{getValue(
															item,
															`auditData.auditCount.not_uploaded_count`,
															""
														)}
														
													</td>
													<td>
														{getValue(
															item,
															`auditData.auditCount.complied_count`,
															""
														)}
														
													</td>
													<td>
														{getValue(
															item,
															`auditData.auditCount.non_complied_count`,
															""
														)}
														
													</td>
													<td>
														{getValue(
															item,
															`auditData.auditCount.not_applicable_count`,
															""
														)}
														
													</td>
													<td>
														{getValue(
															item,
															`auditData.auditCount.partially_complied_count`,
															""
														)}
														
													</td>
													<td>
														{formatDecimal(getValue(
															item,
															`auditData.auditScore.compliance_score`,
															""
														))}
													%
													</td>
												</tr>
											);
										})
									:
										<tr>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td>No Data Found</td>
											<td></td>
											<td></td>
											<td></td>
											</tr>
									}
									</tbody>
								</Table>
							</div>
						</div>
					</div> */}
					</div>
				)}
				<div className="text-right">
					<img src="/images/profile-illustration.svg" className="img-fluid" />
				</div>
			</>
			{/* )} */}
		</DashboardLayout>
	);
}
